<template>
  <div>
    ERROR 404, VOLTE PARA O
    <router-link tag="a" to="/">INICIO CLICANDO AQUI </router-link>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>